import { render, staticRenderFns } from "./modalTurno1.vue?vue&type=template&id=bb8bee92&scoped=true&"
import script from "./modalTurno1.vue?vue&type=script&lang=js&"
export * from "./modalTurno1.vue?vue&type=script&lang=js&"
import style0 from "./modalTurno1.vue?vue&type=style&index=0&id=bb8bee92&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8bee92",
  null
  
)

export default component.exports